import ServiceCard from '@/components/public/cards/ServiceCard';
import Seo from '@/components/public/Seo';
import PageHero from '@/components/public/sections/PageHero';
import ServiceDesks from '@/components/public/sections/ServiceDesks';
import Section from '@/components/public/ui/Section';
import { useSite } from '@/hooks/useSite';
import { ServicesPageDetails } from '@/data/pages/services/details';

export default function ServicesIndex() {
  const services = useSite().services;
  return (
    <>
      <Seo
        title="Serviços"
        description="Aceda a todos os requerimentos, licenças e serviços administrativos de forma ágil e transparente."
      />
      <PageHero
        badge={ServicesPageDetails.badge}
        title={ServicesPageDetails.title}
        accentWord={ServicesPageDetails.accentWord}
        subtitle={ServicesPageDetails.subtitle}
      />

      {/* Catalogue */}
      <Section spacing="md" aria-labelledby="services-heading">
        <h2 id="services-heading" className="sr-only">
          Serviços disponíveis
        </h2>
        {/* Flex-wrap + justify-center so an odd last row (5 cards) stays balanced. */}
        <div className="flex flex-wrap justify-center gap-5">
          {services.map((service) => (
            <div
              key={service.key}
              className="w-full sm:w-[calc(50%-0.625rem)] lg:w-[calc(33.333%-0.834rem)]"
            >
              <ServiceCard
                title={service.title}
                description={service.description}
                icon={service.icon}
                href={service.path}
                color={service.color}
              />
            </div>
          ))}
        </div>
      </Section>

      {/* Balcões de atendimento */}
      <Section spacing="md">
        <ServiceDesks />
      </Section>
    </>
  );
}
